import { useState } from 'react';
import { useStore } from '@/store/main';
import Link from 'next/link';
import cn from 'classnames';
import HopLogo from './Svgs/hoplogo';
import { useLocale } from '@/context/LocaleContext';

const Menu = () => {
  const [menuLinks] = useStore((state) => [state.menuLinks]);
  const [isMenuOpen, setIsMenuOpen] = useStore((state) => [state.isMenuOpen, state.setIsMenuOpen]);
  const [openAccordion, setOpenAccordion] = useState(null);
  const locale = useLocale();

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenAccordion(null);
  };

  return (
    <div
      className={cn(
        'w-full h-[100dvh] fixed top-0 left-0 z-[1000] bg-red flex pb-50 translate-x-full ease-in-out-circ duration-40',
        {
          '!translate-x-0': isMenuOpen
        }
      )}
    >
      <div className="relative w-full mt-auto px-20">
        <div className="mb-10">
          <p className="p2 !text-10 uppercase text-white opacity-40">Secciones</p>
        </div>
        <nav>
          <ul className="">
            {menuLinks.map((link, index) => {
              const hasChildren = Array.isArray(link.children) && link.children.length > 0;
              const isOpen = openAccordion === index;

              if (hasChildren) {
                return (
                  <li key={index} className="mb-20">
                    <button
                      type="button"
                      onClick={() => setOpenAccordion(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      aria-label={`Abrir menú ${link.name}`}
                      className="relative inline-flex items-center py-4"
                    >
                      <p className="font-1 text-28 !font-medium text-white">{link.name}</p>
                      <svg
                        className={cn('w-14 h-auto ml-10 duration-40', { 'rotate-180': isOpen })}
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M1 1L5 5L9 1" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <ul className={cn('overflow-hidden duration-40', isOpen ? 'max-h-[40rem] mt-8' : 'max-h-0')}>
                      {link.children.map((child, ci) => (
                        <li key={ci} className="mb-12 pl-16">
                          <Link
                            href={child.url}
                            locale={child.external ? undefined : locale}
                            target={child.external ? '_blank' : undefined}
                            rel={child.external ? 'noopener noreferrer' : undefined}
                            onClick={closeMenu}
                            aria-label={`Ir a ${child.name}`}
                            className="relative inline-block py-4"
                          >
                            <p className="font-1 text-20 !font-medium text-white opacity-80">{child.name}</p>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              }

              return (
                <li key={link.url} className="mb-20">
                  <Link className="relative inline-block py-4" href={link.url} locale={locale} aria-label={`Ir a ${link.name}`} onClick={closeMenu}>
                    <p className="font-1 text-28 !font-medium text-white">{link.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        <div>
          <Link
            onClick={closeMenu}
            href={'/segui-tu-envio'}
            locale={locale}
            className="w-full py-15 bg-white rounded-full flex items-center justify-center mb-20"
            aria-label="Seguir tu envío - Rastrear el estado de tu paquete"
          >
            <svg
              className="w-21 h-auto mr-6"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11.5"
                cy="8.5"
                r="7.75"
                stroke="#777776"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="1"
                y1="19.8851"
                x2="5.89364"
                y2="14.9915"
                stroke="#777776"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="font-1 text-14 font-normal text-black opacity-60 uppercase">
              Seguí tu Envío
            </span>
          </Link>
          <Link
            onClick={closeMenu}
            href={'/conoce-los-puntos-hop'}
            className="w-full py-10 bg-white rounded-full flex items-center justify-center"
            locale={locale}
            aria-label="Conocer los puntos HOP - Encontrar ubicaciones de entrega"
          >
            <div className="size-34 rounded-full bg-red flex items-center justify-center mr-6 drop-shadow">
              <div className="w-14">
                <HopLogo />
              </div>
            </div>
            <span className="font-1 text-14 font-normal text-black opacity-60 uppercase">
              Conocé los puntos HOP
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Menu;
